<template>
  <div class="event-result">
    <span
      :class="{
        won: status === 1,
        draw: status === 0,
        lost: status === 2
      }"
    >{{ resultText }}</span>
  </div>
</template>

<script>
export default {
  name: 'EventResult',
  props: {
    status: {
      type: Number,
      default: 0 // 0: draw; 1: won; 2: lost
    }
  },
  computed: {
    resultText() {
      if (this.status === 0) {
        return 'D'
      } else if (this.status === 1) {
        return 'W'
      } else {
        return 'L'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.event-result {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;

  span {
    display: block;
    width: 22px;
    height: 22px;
    border-radius: 2px;
    color: #000;
    font-size: 12px;
    line-height: 22px;

    &.won {
      background: #ffbf00;
    }

    &.draw {
      background: #595959;
    }

    &.lost {
      background: #8a6e2e;
    }
  }
}
</style>